import { faMessage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, Typography, SxProps, Theme } from "@mui/material";
import React, { useState } from "react";
import { State } from "./interfaces";
import { StyledIconButton, Title } from "./styles";

export interface CummentBubbleParam {
  title: string;
  comment: string;
  customButtonStyles?: SxProps<Theme>;
}

const CommentBubble = ({ title, comment, customButtonStyles }: CummentBubbleParam) => {
  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });

  return (
    <>
      <StyledIconButton
        onMouseEnter={(event) => {
          event.stopPropagation();
          setState({
            anchorEl: event.currentTarget,
            open: true,
          });
        }}
        onMouseLeave={(event) => {
          event.stopPropagation();
          setState((state) => ({
            ...state,
            open: false,
          }));
        }}
        sx={{ ...(customButtonStyles ? customButtonStyles : {}) }}
      >
        <FontAwesomeIcon icon={faMessage} />
      </StyledIconButton>

      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "center" }}
        sx={{
          pointerEvents: "none",
        }}
        PaperProps={{
          sx: {
            padding: "10px",
            width: "450",
          },
        }}
        disableRestoreFocus
      >
        <Title variant={"body1"}>{title}</Title>
        <Typography variant={"body1"}>{comment}</Typography>
      </Popover>
    </>
  );
};
export default CommentBubble;
